/**
 * The description a CRM view shows. Plan A's `effective_description` is the server's answer
 * (own text, else the intake vacancy's text when this viewer may see it); a present null means
 * "nothing to show", so only an absent field falls back to the stored `description`.
 */
export function opportunityDescription(
  opp: { effective_description?: string | null; description?: string | null } | null | undefined,
): string | null {
  if (!opp) { return null; }
  const text = 'effective_description' in opp ? opp.effective_description : opp.description;
  return typeof text === 'string' && text.trim() !== '' ? text : null;
}
